export const EVENT_BUS_MODAL_CONTEXT = 'modal'
